import { render } from "./BreadcrumbMenu.vue?vue&type=template&id=23f9206a&scoped=true"
import script from "./BreadcrumbMenu.vue?vue&type=script&lang=js"
export * from "./BreadcrumbMenu.vue?vue&type=script&lang=js"

import "./BreadcrumbMenu.vue?vue&type=style&index=0&id=23f9206a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23f9206a"]])

export default __exports__